import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  AccountInfoAccordion,
  AccountInfoTable,
} from '../account-info-accordion/account-info-accordion';
import DetailsTableRow from '../details-table-row/details-table-row';
import DetailsNameTableData from '../details-name-table-data/details-name-table-data';
import DetailsValueTableData from '../details-value-table-data/details-value-table-data';
import NamedKeyValue from '../named-key-value/named-key-value';
import { BodyText } from '@block-explorer/ui';
import { splitKeyOnWords } from '../../utils/nft-token-metadata';
import styled from 'styled-components';
import { ArrowDownIcon, FlexRow, SvgIcon } from '@make-software/cspr-design';
import CopyButton from '../copy-button/copy-button';

const ArrowSvgIcon = styled(SvgIcon)(({ theme }) => ({
  path: {
    fill: theme.styleguideColors.contentBlue,
  },
}));

const CollapsedRow = styled(DetailsTableRow)(({ theme }) => ({
  padding: '16px 0',
  '&:hover': {
    background: 'none',
    span: {
      color: theme.styleguideColors.contentRed,
    },
    [`${ArrowSvgIcon}`]: {
      path: {
        fill: theme.styleguideColors.contentRed,
      },
    },
  },
}));

interface DetailsAccordionContractModalitiesProps {
  purses: any[];
  accordionTitle: React.ReactElement;
  maxVisibleRows?: number;
}

export const DetailsAccordionContractPurse = ({
  purses,
  accordionTitle,
  maxVisibleRows = 4,
}: DetailsAccordionContractModalitiesProps) => {
  const { t } = useTranslation();
  const [isCollapsed, setCollapsed] = useState<boolean>(true);

  const handleExpandList = () => {
    setCollapsed(!isCollapsed);
  };

  return (
    <AccountInfoAccordion
      disableClickAway
      renderContent={() => (
        <AccountInfoTable
          renderData={() => (
            <>
              {purses
                .filter((key, i) => (isCollapsed ? i < maxVisibleRows : true))
                .map((item) => (
                  <DetailsTableRow key={`${item.key}`}>
                    <DetailsNameTableData>
                      {splitKeyOnWords(item.name)}
                    </DetailsNameTableData>
                    <DetailsValueTableData>
                      <FlexRow itemsSpacing={4} align="center">
                        <BodyText size={3} monotype noWrap>
                          <NamedKeyValue namedKey={item.key} />
                        </BodyText>
                        <CopyButton value={item.key} />
                      </FlexRow>
                    </DetailsValueTableData>
                    <td />
                  </DetailsTableRow>
                ))}
              {purses.length > maxVisibleRows && (
                <CollapsedRow onClick={handleExpandList}>
                  <DetailsNameTableData>
                    <BodyText size={3} variation="blue">
                      {isCollapsed ? (
                        <>
                          <Trans t={t}>See all </Trans>
                          {purses?.length}
                          <Trans t={t}> purses</Trans>
                        </>
                      ) : (
                        <Trans t={t}>Hide purses </Trans>
                      )}
                    </BodyText>
                    <ArrowSvgIcon
                      src={ArrowDownIcon}
                      alt={'Arrow down icon'}
                      marginLeft
                      rotate={!isCollapsed}
                    />
                  </DetailsNameTableData>
                  <DetailsNameTableData></DetailsNameTableData>
                </CollapsedRow>
              )}
            </>
          )}
        />
      )}
    >
      {accordionTitle}
    </AccountInfoAccordion>
  );
};
